export function getADAList(t) {
  return [
    { key: 'none', value: t('stationdetails.dropdownlabel_none') },
    { key: 'disabled', value: t('stationdetails.dropdownlabel_disabled') },
    { key: 'van', value: t('stationdetails.dropdownlabel_van') }
  ];
}
